import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./MediaPartners.scss";
import mp1 from "../../images/media-partner/1.webp";
import mp2 from "../../images/media-partner/2.webp";
import mp3 from "../../images/media-partner/3.webp";
import mp4 from "../../images/media-partner/4.webp";
import mp5 from "../../images/media-partner/5.webp";

const MediaPartners = () => {
  const mediaData = [
    {
      id: "01",
      title: "Mega Screens",
      icon: "ti-desktop",
      description:
        "Your brand displayed on giant LED screens throughout the venue, ensuring maximum visibility.",
      metric: "Estimated impressions: 10,000+",
    },
    {
      id: "02",
      title: "Event Magazine",
      icon: "ti-book",
      description:
        "Premium advertising space in our official event magazine distributed to all attendees.",
      metric: "Print run: 60,000 copies",
    },
    {
      id: "03",
      title: "Social Media",
      icon: "ti-share-alt",
      description:
        "Extensive coverage across our social media platforms with a combined reach of over 500,000 followers.",
      metric: "Platforms: LinkedIn, Twitter, Instagram, Facebook",
    },
  ];

  const partnerData = [
    {
      id: "01",
      name: "Economic Times",
      image: mp1,
    },
    {
      id: "02",
      name: "NDTV Profit",
      image: mp2,
    },
    {
      id: "03",
      name: "Forbes India",
      image: mp3,
    },
    {
      id: "04",
      name: "Bloomberg",
      image: mp4,
    },
    {
      id: "05",
      name: "CNBC",
      image: mp5,
    },
  ];

  const settings = {
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
    infinite: true,
    dots: false,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <section className="media-partners-section section-padding">
      <div className="container">
        {/* Media & Branding Section */}
        <div className="row">
          <div className="col-lg-12">
            <div className="section-title text-center">
              <h2>Media & Branding</h2>
              <p>
                Maximize your brand's visibility through our comprehensive media
                coverage and marketing channels.
              </p>
            </div>
          </div>
        </div>
        <div className="row mt-5">
          {mediaData.map((item) => (
            <div key={item.id} className="col-lg-4 col-md-6">
              <div className="media-card">
                <div className="media-icon">
                  <i className={item.icon}></i>
                </div>
                <h4>{item.title}</h4>
                <p>{item.description}</p>
                <div className="media-metric">{item.metric}</div>
              </div>
            </div>
          ))}
        </div>

        {/* Previous Media Partners Section */}
        <div className="row mt-5">
          <div className="col-lg-12">
            <div className="section-title">
              <h2>Previous Media Partners</h2>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-12">
            <div className="partners-slider">
              <Slider {...settings}>
                {partnerData.map((partner) => (
                  <div key={partner.id} className="partner-item">
                    <div className="partner-icon">
                      <img src={partner.image} alt={partner.name} />
                    </div>
                    <span>{partner.name}</span>
                  </div>
                ))}
              </Slider>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MediaPartners;
